import { render, staticRenderFns } from "./IpRegistrationPage.vue?vue&type=template&id=76e2ebc8"
import script from "./IpRegistrationPage.vue?vue&type=script&lang=js"
export * from "./IpRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports